
import Vue from "vue"

export default Vue.extend({
  props: {
    settings: { type: Object, default: () => ({}) },
  },
})
